<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emWorkflowListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content" v-menu-permission="'list'">
        <div class="card">
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi" ref="emListFilter"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="sithMesStool26StockTransferResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table :entity="modelName" inlineActionsDisabled :query-api="$_emWorkflowListMixin_queryApi"
                        :ref="modelName+'Table'"  checkboxColumnDisabled withCustomRowActions
                        with-custom-row-actions-first-column>
                <template slot="left-header">
                  <em-button type="search"
                    v-bind:class="'btn btn-outline-primary btn-sm'"
                    :customLabel="isClaim ? '认领' : '待办'"
                    :custom-icon="'fa ' + (isClaim ? 'fa-toggle-on' : 'fa-toggle-off')"
                    :busy="emWorkflowListLoading"
                    show-name
                    @click="switchClaim">
                  </em-button>
                </template>

                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                    <em-button type="task"
                        :busy="claimLoading"
                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                        :custom-label="isClaim ? '认领' : '处理'"
                        @click="handleExecute(customRowScope.row)">
                    </em-button>
                </template>

              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
  </div>
</template>
<script>
  // Author Shi Wen Long
  // Date 2022-04-26 16:31:56
  import emWorkflowListMixin from "@/mixin/em/workflow/list";

  export default {
    name: "sithMesStool26StockTransferWorkflowListView",
    mixins: [emWorkflowListMixin],
    computed: {
      modelName() {
        return this.$_emRouterHelperMixin_entityName
      },
      $_emRouterHelperMixin_pathType() {
            return this.isClaim ? 'claim' : this.$route.query.pathType;
      },
      pathType() {
            return this.$route.query.pathType;
      },
    },
    watch: {
        pathType() {
            this.isClaim = false;
        }
    },
    data() {
        return {
          isClaim: false,
          claimLoading: false,
      }
    },
    methods: {
      switchClaim() {
        this.isClaim = !this.isClaim;
      },
      handleExecute(row) {
        console.log(row)
        if (this.isClaim) {
            if (row.workflowTask && row.workflowTask.processDefinitionKey) {
                this.claimLoading = true;
                this.$store.dispatch('api/post', {
                    url: this.$store.state.sithMesStool26StockTransfer.baseModuleUrl + "/sithMesStool26StockTransfer/claimTask",
                    data: {
                        processDefinitionKey: row.workflowTask.processDefinitionKey,
                        businessKeyList: [row.id]
                    }
                }).then(() => {
                    this.claimLoading = false;
                    this.$message.success("认领成功");
                    this.$_emWorkflowListMixin_init();
                });
            }
        } else {
            this.$_emWorkflowListMixin_handleApprove(row);
        }
      },
    },
    mounted() {
        if (this.$route.query.toClaim) {
            this.isClaim = true;
        }
        if (this.$route.query.hasOwnProperty('processId')) {
          this.$nextTick(() => {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.processId);
            this.$refs.emListFilter.doQuery();
          })
        }
    },
  };
</script>